import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const breadcrumbThemeToken: any = {
  //======================== COLOR ====================================//
  itemColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  lastItemColor: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  linkColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  linkHoverColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  separatorColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue10"],
  colorBgTextHover: "transparent",

  //======================== SIZE ====================================//
  fontSize: variableTypography["BodyMediumFontSize"],
  iconFontSize: variableTypography["BodyMediumFontSize"],
  separatorMargin: 8,

  //======================== FONT ====================================//
  fontFamily: variableTypography["BodyMediumFontFamily"],
};
